import { render, staticRenderFns } from "./BaseProductActionableLink.vue?vue&type=template&id=2f6431c0&"
import script from "./BaseProductActionableLink.vue?vue&type=script&lang=js&"
export * from "./BaseProductActionableLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6431c0')) {
      api.createRecord('2f6431c0', component.options)
    } else {
      api.reload('2f6431c0', component.options)
    }
    module.hot.accept("./BaseProductActionableLink.vue?vue&type=template&id=2f6431c0&", function () {
      api.rerender('2f6431c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/actionableLink/BaseProductActionableLink.vue"
export default component.exports